import React from 'react';
import { FormattedMessage } from "react-intl";
import {
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Stack,
  Typography,
  Tooltip,
} from '@mui/material';

import EditIcon from '@mui/icons-material/ModeEdit';
import DeleteIcon from '@mui/icons-material/DeleteForever';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

const PriceModelPropertiesTable = ({
  properties = [],
  onEditProperty,
  onDeleteProperty,
  onMoveUp,
  onMoveDown,
}) => {

  if (!properties.length) {
    return (
      <Box sx={{ py: 6, textAlign: 'center' }}>
        <Typography variant="body1" color="text.secondary">
          <FormattedMessage id="admin.pricemodels.properties.empty" />
        </Typography>
      </Box>
    );
  }

  const getDisplayModeText = (displayMode) => {
    switch (displayMode) {

      case "SELECT_MULTIPLE_CHECKBOX":
        return "Välj flera (checkboxar)";

      case "SELECT_ONE_DROPDOWN_OPTIONAL":
        return "Välj en (valfri)";

      case "SELECT_ONE_DROPDOWN_REQUIRED":
        return "Välj en (obligatorisk)";

      case "SELECT_ONE_RADIO_REQUIRED":
        return "Radioknappar (obligatorisk)";

      case "SELECT_ONE_SWITCH":
        return "Switch";

      default:
        return displayMode || "";
    }
  };

  return (
    <Table size="small">
      <TableHead>
        <TableRow>

          <TableCell>
            <FormattedMessage id="admin.pricemodels.table.name" />
          </TableCell>

          <TableCell>
            <FormattedMessage id="admin.pricemodels.table.label" />
          </TableCell>



          <TableCell>
            <FormattedMessage id="admin.pricemodels.properties.table.defaultArtno"/>
          </TableCell>

          <TableCell>
            <FormattedMessage id="admin.pricemodels.properties.table.displayMode" />
          </TableCell>

          <TableCell align="right">
            <FormattedMessage id="admin.pricemodels.table.actions" />
          </TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {properties.map((property, index) => {
          const isFirst = index === 0;
          const isLast = index === properties.length - 1;

          return (
            <TableRow key={property.id || index} hover>

              <TableCell>
                  {property.name}
              </TableCell>
              
              <TableCell>
                {property.label}
              </TableCell>
                            
              <TableCell>
                {property.defaultArtNo}
              </TableCell>

              <TableCell>
                {getDisplayModeText(property.displayMode)}
              </TableCell>

              

              {/* ACTIONS */}
              <TableCell align="right">
                <Stack
                  direction="row"
                  spacing={1}
                  justifyContent="flex-end"
                >

                  {/* MOVE UP */}
                  <Tooltip title={<FormattedMessage id="btn.moveUp" />}>
                    <span>
                      <IconButton
                        size="small"
                        disabled={isFirst}
                        onClick={() => onMoveUp?.(property, index)}
                      >
                        <ArrowUpwardIcon fontSize="small" />
                      </IconButton>
                    </span>
                  </Tooltip>

                  {/* MOVE DOWN */}
                  <Tooltip title={<FormattedMessage id="btn.moveDown" />}>
                    <span>
                      <IconButton
                        size="small"
                        disabled={isLast}
                        onClick={() => onMoveDown?.(property, index)}
                      >
                        <ArrowDownwardIcon fontSize="small" />
                      </IconButton>
                    </span>
                  </Tooltip>

                  {/* EDIT */}
                  <Tooltip title={<FormattedMessage id="btn.edit" />}>
                    <IconButton
                      size="small"
                      onClick={() => onEditProperty?.(property)}
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>

                  {/* DELETE */}
                  <Tooltip title={<FormattedMessage id="btn.delete" />}>
                    <IconButton
                      size="small"
                      color="error"
                      onClick={() => onDeleteProperty?.(property)}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>

                </Stack>
              </TableCell>

            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default PriceModelPropertiesTable;